/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import Media from 'react-media';

import Imgix from 'js/components/Imgix';

import type { StaticComponentProps } from 'bundles/coursera-plus-landing-page/components/heroContentful/Hero';
import LegacyDesktop from 'bundles/coursera-plus-landing-page/components/heroContentful/LegacyDesktop';
import LegacyMobile from 'bundles/coursera-plus-landing-page/components/heroContentful/LegacyMobile';
import {
  YES_I_CAN_IMAGE_SIZES,
  mobileBreakpoint,
  xlImageBreakpoint,
} from 'bundles/coursera-plus-landing-page/components/heroContentful/design/constants';
import { HIDDEN_SLUG_FOR_DEFAULT_LANDING_PAGE } from 'bundles/coursera-plus-landing-page/contentful/constants';

import landingmidyear from 'images/coursera-plus/landingmidyear.png';

const styles = {
  container: (backgroundColor: string) => css`
    padding: 20px 0;
    background-color: ${backgroundColor};
  `,
};

const desktopStyles = {
  rightSideContainer: () => css`
    display: flex;
    align-items: center;
    align-content: flex-end;
    height: 100%;
  `,
};

export const YesICanImageDesktop = (props: { imageUrl?: string; width: number }) => {
  const { width } = props;
  const height = width * YES_I_CAN_IMAGE_SIZES.heightWidthRatio;

  return (
    <div css={desktopStyles.rightSideContainer}>
      <Imgix src={props.imageUrl ?? landingmidyear} alt={Imgix.DECORATIVE} maxWidth={width} maxHeight={height} />
    </div>
  );
};

const YesICan = (props: StaticComponentProps) => {
  const isDefaultLandingPage = props.slug === HIDDEN_SLUG_FOR_DEFAULT_LANDING_PAGE;

  let backgroundColor;
  if (isDefaultLandingPage) {
    backgroundColor = '#f3f8ff';
  } else {
    // The background color is white on promo pages
    backgroundColor = '#ffffff';
  }

  const img = props.imageUrl ?? landingmidyear;
  const isMobile = props.userAgent?.isMobileBrowser ?? false;
  return (
    <div css={styles.container(backgroundColor)}>
      <Media
        queries={{ xxlImage: `(min-width: ${xlImageBreakpoint}px)`, xlImage: `(min-width: ${mobileBreakpoint}px)` }}
        defaultMatches={{ xxlImage: !isMobile, xlImage: !isMobile }}
      >
        {(matches) => {
          if (matches.xxlImage) {
            return (
              <LegacyDesktop slug={props.slug}>
                <YesICanImageDesktop width={YES_I_CAN_IMAGE_SIZES.xxlImageWidth} imageUrl={props.imageUrl} />
              </LegacyDesktop>
            );
          } else if (matches.xlImage) {
            return (
              <LegacyDesktop slug={props.slug}>
                <YesICanImageDesktop width={YES_I_CAN_IMAGE_SIZES.xlImageWidth} imageUrl={props.imageUrl} />
              </LegacyDesktop>
            );
          } else {
            return <LegacyMobile imageUrl={img} defaultRatio={YES_I_CAN_IMAGE_SIZES.heightWidthRatio} />;
          }
        }}
      </Media>
    </div>
  );
};

export default YesICan;
